import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'statusClass'
})
export class StatusClassPipe implements PipeTransform {
  transform(status: string | null | undefined): string {
    if (!status) return '';

    const s = status.toLowerCase();

    if (s === 'locked' || s.includes('pending') || s === 'scheduled') return 'status-orange';
    if (s === 'active' || s.includes('approve') || s === 'open' || s === 'y' || s === 'enabled' || s === 'in_use') return 'status-green';
    if (s.includes('reject') || s.includes('suspend') || s === 'cancel' || s === 'failed' || s === 'n' || s === 'expired')
      return 'status-red';
    if (
      s === 'inactive' ||
      s === 'close' ||
      s === 'draft' ||
      s === 'disabled' ||
      s === 'blacklisted' ||
      s === 'cancelled' ||
      s === 'expired'
    )
      return 'status-grey';
    if (s === 'new' || s === 'revision' || s === 'revert' || s === 'reverted' || s === 'posted') return 'status-blue';

    return '';
  }
}
